export default defineNuxtRouteMiddleware((to) => {
  const config = useRuntimeConfig();
  // Explicitly cast FRONTEND_URL to string, fallback to default if undefined
  const targetDomain = (config.public.frontEndUrl) || 'https://www.spring-green.com';
  let currentDomain = '';

  // SSR: use request headers
  if (import.meta.server) {
    const headers = useRequestHeaders(['host']);
    currentDomain = headers.host || '';
  }

  // Client: use window.location
  if (import.meta.client) {
    currentDomain = window.location.host;
  }

  if (
    currentDomain &&
    !currentDomain.includes(targetDomain.replace(/^https?:\/\//, '')) &&
    !targetDomain.includes(currentDomain)
  ) {
    return navigateTo(targetDomain + to.fullPath, { external: true });
  }
});
